import React from 'react';
import auth0Client from './Auth';
import {deleteCookie} from "../../utils/utils"

type myProps = {
    show: boolean,
  };
  
type myState = {
    show: boolean,
    getLoggedOut: boolean
}

class Logout extends React.Component<myProps, myState> {
    constructor(props: any){
      super(props);
      this.state={
          show: this.props.show,
          getLoggedOut: false
      }
    }
    render(){
        if(this.state.getLoggedOut){
            return (<div></div>)
        } else if(this.state.show){
            return <div style={style}onClick = {(event)=> this.handleClick(event)}>Logout</div>
        } else {
            return <div></div>
        }
        
       
    }
    handleClick(event: any){
        this.setState({getLoggedOut: true})
        window.localStorage['isLogged']= false;
        auth0Client.signOut();
        deleteCookie("auth_token");
        const baseUrl = window.location.origin;
        window.location.href = `https://${process.env.REACT_APP_AUTH0_DOMAIN}/v2/logout?returnTo=${baseUrl}`;
    }
}
const style = {
    cursor: 'pointer',
    width: 60,
    height: 35,

}
export default Logout


// WEBPACK FOOTER //
// ./src/components/Login/Logout.tsx